var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-checkbox-group",
    {
      attrs: { disabled: _vm.disabled, size: _vm.size },
      on: { change: _vm.onChange },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    _vm._l(_vm.options, function (item, index) {
      return _c(
        "el-checkbox",
        { key: index, attrs: { label: item.value, disabled: !!item.disabled } },
        [_vm._v(_vm._s(item.label))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }